<div [style.width]="deviceDetectorService.isMobile() ? '100%' : '480px'" class="p-2">
  <div class="mt-3 mb-3">
    <div class="row justify-content-between">
      <div class="col-auto">
        <div class="d-flex align-items-center">
          <span class="desktop_body_p5">
            Histórico
          </span>
        </div>
      </div>
      <div class="col-auto">
        <button class="btn" (click)="fechar()" type="button">
          <img src="assets/imgs/icones/close-black.svg" alt="">
        </button>
      </div>
    </div>
  </div>
  <div class="ps-3 pe-3 pb-3" style="height: calc(100vh - (66px + 86px)); overflow: auto">
    <div *ngFor="let p of parceriaService.modelListaProposta">
      <div [ngSwitch]="p.origem">
        <div *ngSwitchCase="'Parceiro'" class="mb-3">
          <div class="card bg-gray-chat p-3 border-0" style="box-shadow: unset; border-radius: 8px 8px 0px 8px">
            <div class="mb-3">
                <span class="texto-inter">
                  {{p.observacao}}
                </span>
            </div>
            <div class="card">
              <div>
                <app-item-texto
                  [titulo]="'Proposta'"
                  [conteudo]="p.valorProposta | currency:'BRL':'symbol':'1.2-2'"
                ></app-item-texto>
              </div>
            </div>
          </div>
          <div class="w-100" style="position: relative; top: -5px">
            <div class="d-flex flex-column align-items-end">
              <div class="d-flex">
                <div class="d-flex align-items-center justify-content-center align-content-center">
                  <span class="data-chat">{{ p.dataProposta ? moment(p.dataProposta).format("DD/MM/YYYY - HH:mm") : "-"}}</span>
                </div>
                <div>
                  <img src="assets/imgs/vetor/vetor-triangulo-cinza.svg" alt="">
                </div>
              </div>
            </div>
          </div>
        </div>
        <div *ngSwitchCase="'Pjus'" class="mb-3">
          <div class="card p-3 border-0" style="background-color: #0061D6; box-shadow: unset; border-radius: 8px 8px 8px 0">
              <div class="mb-2">
                <span class="texto-inter text-white">
                   {{p.observacao}}
                </span>
              </div>

              <div class="card">
                <div class="mb-3">
                  <app-item-texto
                    [titulo]="'Proposta'"
                    [conteudo]="p.valorProposta | currency:'BRL':'symbol':'1.2-2'"
                  ></app-item-texto>
                </div>
                <div class="mb-3">
                  <app-item-texto
                    [titulo]="'Comissão'"
                    [conteudo]="p.valorComissao | currency:'BRL':'symbol':'1.2-2'"
                  ></app-item-texto>
                </div>
                <div class="mb-3">
                  <app-item-texto
                    [titulo]="'Vencimento'"
                    [conteudo]="moment(p.dataVencimento).format('DD/MM/YYYY')"
                  ></app-item-texto>
                </div>
                <div class="row" *ngIf="hoje <= data(p.dataVencimento) && p.tipoOferta !== 'ContraPropostaReprovada'">
                  <div class="col-12 col-md-6">
                    <button class="btn btn-primary w-100"
                            type="button"
                      (click)="aceiteProposta(p)"
                    >
                      Aceitar <img class="ms-2" src="assets/imgs/icones/check.svg" alt="">
                    </button>
                  </div>
                  <div class="col-12 col-md-6">
                    <a class="btn btn-outline-secondary texto-2--color-segundario w-100" target="_blank" [href]="p.urlDocumento">
                      Baixar proposta <img class="" src="assets/imgs/icones/download.svg" alt="">
                    </a>
                  </div>
                </div>
                <div class="text-center texto-3 texto-3--color-segundario d-flex align-content-center
                align-items-center justify-content-center" *ngIf="hoje > data(p.dataVencimento)">
                  <div class="alerta-circulo alerta-circulo-neutro me-2"></div>
                  <span>Proposta cancelada</span>
                </div>
              </div>
              <div class="bg-white" style="border-radius: 42px;
              border: solid 1px #0061D6;
              width: fit-content;position: absolute;bottom: 8px;left: 4px;">
                <img src="assets/imgs/icones/pjus-logo-icone.svg" alt="">
              </div>

            </div>
          <div class="d-flex" style="position: relative; top: -5px">
              <div>
                <img src="assets/imgs/vetor/vetor-triangulo-azul.svg" alt="">
              </div>
              <div class="d-flex align-items-center justify-content-center align-content-center">
                <span class="data-chat">{{ p.dataProposta ? moment(p.dataProposta).format("DD/MM/YYYY - HH:mm") : "-"}}</span>
              </div>
            </div>
        </div>
      </div>
    </div>
  </div>
</div>
